module.exports = __webpack_public_path__ + "img/matlab.2f054786.png";